import React from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { EditTransactionForm } from "../../components/transaction";

export const EditTransaction = () => {
  const { id } = useParams();
  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title="Edit Transaction" />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <EditTransactionForm transactionId={id} />
      </Box>
    </PageLayout>
  );
};
